import type { DistributionUICustomization } from "@searchui-searchforms/shared/customization";
import styles from "./buttonWidth.module.scss";

const BUTTON_WIDTH_MAP: Record<NonNullable<DistributionUICustomization["controlButtonsWidth"]>, string> = {
    full: styles.full!,
    "full-sm": styles.fullSm!,
    "full-md": styles.fullMd!,
};

export const getButtonWidthClass = (
    controlButtonsWidth: DistributionUICustomization["controlButtonsWidth"],
): string | undefined => {
    if (controlButtonsWidth) return BUTTON_WIDTH_MAP[controlButtonsWidth];
    return "";
};
